import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from 'src/config/config';
import { apiConstants } from "../constant/apiConstant";
import { map } from 'rxjs';
import { commonFunctionService } from '../utils/commonFunctions';

@Injectable({
    providedIn: 'root'
})

export class ExpenseReportServices {
    private URL_V3 = AppSettings.API_ENDPOINT_V3;
    headers: HttpHeaders;
    private language = "en";
    constructor(private http: HttpClient, private commonFunction: commonFunctionService) { }

    getAcademicYears() {
        return this.http
            .get(this.URL_V3 + apiConstants.getAcademicYearsList, {
                headers: this.commonFunction.appendHeader(),
                params: { lang: this.language },
            })
            .pipe(map((res) => res));
    }

    getPayeeType(body) {
        return this.http
            .post(this.URL_V3 + apiConstants.getPayeeType, body, {
                headers: this.commonFunction.appendHeader()
            })
            .pipe(map((res) => res));
    }

    getPayeeName(body) {
        return this.http
            .post(this.URL_V3 + apiConstants.getPayeeName, body, {
                headers: this.commonFunction.appendHeader()
            })
            .pipe(map((res) => res));
    }

    getPaymentMethod(body) {
        return this.http
            .post(this.URL_V3 + apiConstants.getPaymentMethod, body, {
                headers: this.commonFunction.appendHeader()
            })
            .pipe(map((res) => res));
    }

    getStatData(body) {
        return this.http
            .post(this.URL_V3 + apiConstants.getStatData, body, {
                headers: this.commonFunction.appendHeader()
            })
            .pipe(map((res) => res));
    }


    getReportData(body) {
        return this.http
            .post(this.URL_V3 + apiConstants.getReportData, body, {
                headers: this.commonFunction.appendHeader()
            })
            .pipe(map((res) => res));
    }

    exportReportData(body) {
        return this.http
            .post(this.URL_V3 + apiConstants.exportExpenseReport, body, {
                headers: this.commonFunction.appendHeader()
            })
            .pipe(map((res) => res));
    }

}